import { render, staticRenderFns } from "./LegalCaseEditorPartyFields.vue?vue&type=template&id=4decf7dd&"
import script from "./LegalCaseEditorPartyFields.vue?vue&type=script&lang=js&"
export * from "./LegalCaseEditorPartyFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports